<script setup>
  import { computed, ref } from "vue";

  import { EXTEND_TIME_OPTIONS } from "@/utils/constant";

  const props = defineProps({
    show: {
      type: Boolean,
      required: true,
    },
    nextTour: { type: Function, required: true },
  });

  const emits = defineEmits(["update:show"]);

  const localShow = computed({
    get: () => props.show,
    set: (val) => emits("update:show", val),
  });

  const closeModal = () => {
    emits("update:show", false);
  };
  const unlock = () => {
    props.nextTour();
    emits("update:show", false);
  };

  const reApplyType = ref();
  const reApplyReason = ref("1");
  const extendTime = ref();

  const REAPPLY_TYPE_OPTIONS = [
    { label: "이어서 진행", value: "continue" },
    { label: "기존 답안 삭제 후 초기화 진행", value: "reset" },
  ];
  const REAPPLY_REASON_OPTIONS = [
    { label: "교사 확인 재응시 처리", value: "1" },
  ];

  // Tour 처리
  const afterEnter = () => {
    props.nextTour();
  };

</script>

<template>
  <ui-modal
    v-model:show="localShow"
    title="재응시 설정"
    :maskClosable="true"
    size="xs"
    @after-enter="afterEnter"
  >
    <template #body>
      <n-flex
        vertical
        :size="8"
        class="rounded-xl bg-gray-100 p-4 [&_dl]:flex [&_dt]:basis-[100px] [&_dt]:text-gray-600"
      >
        <dl>
          <dt>이름</dt>
          <dd>홍길동</dd>
        </dl>
        <dl>
          <dt>학년-반</dt>
          <dd>4-1</dd>
        </dl>
        <dl>
          <dt>시험 상태</dt>
          <dd>시험 중단</dd>
        </dl>
      </n-flex>
      <n-radio-group
        v-model:value="reApplyType"
        name="reApplyType"
        class="mt-2 w-full rounded-xl border"
        @change="afterEnter"
      >
        <n-flex vertical align="flex-start" :size="0">
          <n-radio
            v-for="(type, typeIndex) in REAPPLY_TYPE_OPTIONS"
            :id="'tour-reapply-modal-radio-' + type.value"
            :key="type.value"
            :value="type.value"
            class="w-full px-4 py-3"
            :class="{ 'border-b': typeIndex === 0 }"
          >
            <n-flex align="center" :size="4">
              <ui-chip color="gray" variant="outlined" size="sm"
                >재응시</ui-chip
              >
              <span>{{ type.label }}</span>
            </n-flex>
          </n-radio>
        </n-flex>
      </n-radio-group>
      <ui-table variant="bordered" container-class="mt-2">
        <colgroup>
          <col style="width: 100px" />
          <col style="width: auto" />
        </colgroup>
        <tbody>
          <tr>
            <th class="text-center">사유</th>
            <td>
              <n-select
                size="tiny"
                v-model:value="reApplyReason"
                :options="REAPPLY_REASON_OPTIONS"
              />
            </td>
          </tr>
          <tr>
            <th class="text-center">추가시간</th>
            <td>
              <n-select
                size="tiny"
                v-model:value="extendTime"
                :options="EXTEND_TIME_OPTIONS"
              />
            </td>
          </tr>
          <tr>
            <th class="text-center">종료시간</th>
            <td>2025.08.12 16:04</td>
          </tr>
        </tbody>
      </ui-table>
    </template>
    <template #footer>
      <div class="btn-area justify-end">
        <ui-button variant="outlined" color="gray" @click="closeModal"
          >취소
        </ui-button>
        <ui-button
          id="tour-reapply-modal-chn"
          @click="unlock"
        >변경</ui-button>
      </div>
    </template>
  </ui-modal>
</template>
